import { Component, OnInit, ElementRef, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { CompanyService } from '../../../_services/company.service';
import { PlaceService } from '../../../_services/place.service';
declare var jQuery: any;
import '../../../../assets/semantic/semantic.min.js';
import { DemandService } from '../../../_services/demand.service';
import { IMyDpOptions } from 'mydatepicker';

@Component({
  selector: 'app-new-demand',
  templateUrl: './new-demand.component.html',
  styleUrls: ['./new-demand.component.css']
})
export class NewDemandComponent implements OnInit {

  @Output() refresh: EventEmitter<boolean> = new EventEmitter<boolean>();
  private creating_demand: boolean = false;
  private add_company = false;

  public myDatePickerOptions: IMyDpOptions = {
    // other options...
    dateFormat: 'dd/mm/yyyy',
    openSelectorOnInputClick: true,
    editableDateField: false
  };

  constructor(private elRef: ElementRef, private service: DemandService, private company_service: CompanyService, private place_service: PlaceService) { }

  new_demand = new FormGroup({
    number: new FormControl(),
    client_id: new FormControl('', [Validators.required]),
    receiver_id: new FormControl(''),
    departure_id: new FormControl('', [Validators.required]),
    arrival_id: new FormControl('', [Validators.required]),
    vehicle: new FormControl('', [Validators.required]),
    quantity: new FormControl('', [Validators.required]),
    departure_date: new FormControl(''),
    arrival_date: new FormControl(''),
    sell_price: new FormControl(),
    frequency: new FormControl(0),
    note: new FormControl()
  });

  new_company = new FormGroup({
    email: new FormControl(''),
    name: new FormControl('', [Validators.required]),
    phone: new FormControl('')
  });

  ngOnInit() {
  }

  openModal(field_object: { field, value }) {
    if (field_object) {
      if (field_object.field == "departure_id") this.new_demand.patchValue({ departure_id: field_object.value });
      if (field_object.field == "arrival_id") this.new_demand.patchValue({ arrival_id: field_object.value });
    }

    // jQuery('.ui.radio.checkbox').checkbox('uncheck');
    jQuery('#add-demand-modal').modal({ inverted: true }).modal('show');
  }

  newCompany(name) {
    this.new_company.patchValue({ name: name });
    this.new_demand.patchValue({ client_id: 0 });
    this.add_company = true;
  }

  submitDemandForm() {
    this.new_demand.disable();
    this.creating_demand = true; // Disable the loading button apparition
    jQuery('#add-demand-modal').modal({ closable: false })
    // Set Dates values correctly
    if (this.new_demand.value.departure_date && this.new_demand.value.departure_date.formatted) this.new_demand.patchValue({ departure_date: this.new_demand.value.departure_date.formatted })
    if (this.new_demand.value.arrival_date && this.new_demand.value.arrival_date.formatted) this.new_demand.patchValue({ arrival_date: this.new_demand.value.arrival_date.formatted })

    if (this.add_company) {
      this.new_company.disable();
      this.company_service.createCompany(this.new_company.value) // Create the Contact
        .subscribe(response => {
          this.new_demand.patchValue({ client_id: response.id });
          this.createDemand();
        });
    } else {
      this.createDemand();
    }
  }

  createDemand() {
    this.service.createDemand(this.new_demand.value)
      .subscribe(response => {
        jQuery('#add-demand-modal').modal({ closable: true }).modal('hide'); // Set the modal closable & Close the modal
        this.creating_demand = false; // Disable the loading button apparition
        this.new_demand.enable(); // Re Enable the Form
        // this.new_demand.reset(); // Reset FormGroup
        this.refresh.emit(true); // Emmit the refresh Event
      })
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/_components/demand/new-demand/new-demand.component.ts